import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
} from "@mui/material";
import { InputRut } from "src/shared/components/forms/InputRut";
import { useEffect, useState } from "react";
import { valuesFormReservationGuestState } from "src/Patient/state/atoms";
import {
  useRecoilValue,
  useRecoilValue_TRANSITION_SUPPORT_UNSTABLE,
  useSetRecoilState,
} from "recoil";
import { validateRutChilean } from "src/shared/global/helpers";
import { userState } from "src/store/user/userState";
import AgendamientoInconcluso from "src/services/agenda/agendamientoInconcluso";
import { existPatientState } from "src/SearchHours/state/atoms";

export default function ModalRut() {
  const [showModalRut, setshowModalRut] = useState(false);
  const valuesFormReservationGuest = useRecoilValue(
    valuesFormReservationGuestState
  );
  const user = useRecoilValue_TRANSITION_SUPPORT_UNSTABLE(userState);

  const handleClose = async () => {
    await getPatient(valuesFormReservationGuest.uprRut);
    setshowModalRut(false);
  };

  const disableButton = () => {
    const { uprRut } = valuesFormReservationGuest;
    const isValidRut = uprRut ? validateRutChilean(uprRut).ok : false;
    let flag = false;

    if (!uprRut || !isValidRut) {
      flag = true;
    }
    return !flag;
  };

  useEffect(() => {
    if (
      !user.isAuthenticated &&
      (valuesFormReservationGuest.uprRut === "" ||
        valuesFormReservationGuest.uprRut === null)
    ) {
      setshowModalRut(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const setExistPatient = useSetRecoilState(existPatientState);
  const getPatient = async (rut) => {
    try {
      const { data } = await AgendamientoInconcluso.existPatient(rut);
      setExistPatient(data);
      return data;
    } catch (error) {
      console.log(error);
      return null;
    }
  };

  return (
    <Dialog open={showModalRut} fullWidth maxWidth="xs">
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 2,
          p: 2,
          borderBottom: 1,
          borderColor: "divider",
        }}
      >
        Ingrese el RUT del paciente
      </DialogTitle>
      <DialogContent sx={{ mt: 2, mb: 2 }}>
        <InputRut styles={{}} />
      </DialogContent>
      <DialogActions sx={{ p: 2, borderTop: 1, borderColor: "divider" }}>
        <Stack
          direction="row"
          spacing={2}
          justifyContent="flex-end"
          width="100%"
        >
          <Button
            onClick={() => {
              window.location.href = process.env.REACT_APP_ROOT_SERVER_PATH;
            }}
            variant="outlined"
            color="primary"
            size="small"
          >
            Volver
          </Button>
          <Button
            disabled={!disableButton()}
            onClick={handleClose}
            variant="contained"
            color="primary"
            size="small"
          >
            Aceptar
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );
}
